// @flow
import type {Element, Node} from 'react'
import React, {Component} from 'react'

import {type Severity} from 'components/ui/Alert'
import InnerContent from './InnerContent'
import WrappedContent from './WrappedContent'
import styles from './index.scss'

type Props = {
  alertMessage: ?string,
  alertSeverity: ?Severity,
  children: Node,
  lostChanges: boolean,
}

class Summary extends Component<Props> {
  static defaultProps: {
  alertMessage: null,
  alertSeverity: null,
  children: null,
  lostChanges: boolean,
} = {
      alertMessage: null,
      alertSeverity: null,
      children: null,
      lostChanges: false,
    }

  get children(): Node[] {
    return React.Children.toArray(this.props.children)
      .filter(Boolean)
  }

  renderInnerContent: (() => Node) = () => (
    <InnerContent>
      {this.children}
    </InnerContent>
  )

  renderWrapperContent: ((alertMessage: string) => Node) = (alertMessage: string) => (
    <WrappedContent
      alertMessage={alertMessage}
      alertSeverity={this.props.alertSeverity}
      lostChanges={this.props.lostChanges}
    >
      {this.children}
    </WrappedContent>
  )

  render(): Element<"div"> {
    return (
      <div
        className={styles.summary}
        test-id="proposal-builder-summary-view"
      >
        {this.props.alertMessage
          ? this.renderWrapperContent(this.props.alertMessage)
          : this.renderInnerContent()
        }
      </div>
    )
  }
}

export default Summary
